module.exports = __webpack_public_path__ + "static/media/PersonIcon.ae95f357.svg";